import { render, staticRenderFns } from "./LogoTile.vue?vue&type=template&id=31f335d2&"
var script = {}
import style0 from "./LogoTile.vue?vue&type=style&index=0&id=31f335d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports